import { render, staticRenderFns } from "./TabCover.vue?vue&type=template&id=2c212bec&"
import script from "./TabCover.vue?vue&type=script&lang=js&"
export * from "./TabCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports